export default {"src":"/_next/static/media/logo_loading.2713f0aa.gif","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};